import * as React from "react";
import { ConfigFieldDatePicker } from '../forms/informedv2/ConfigFieldDatePicker';
import { Form, useFormApi } from "informed";
import { ErrorBoundary } from "../././errors/ErrorBoundary";
import * as Moment from 'moment';
import { DatePickerAcceptDateRange } from '../forms/informedv2/DatePicker';
import { ConfigurableDataItemIds } from '../misc/api/ApiConfigurableDataItems';
import { TextBox } from "../forms/informedv2/TextBox";
import { Checkbox } from "../forms/informedv2/Checkbox";

interface TerminationDateModalBodyProps {
    disabled: boolean;
    onSubmit: (values: EarlyTerminationForm) => void;
    onCloseModal: () => void;
    initialValues: EarlyTerminationForm;
}

export interface EarlyTerminationForm {
    SubjectNumber?: string;
    IsTerminated: boolean;
    TerminationDate: string;
}

export const TerminationDateModalBodyForm = ({ disabled, onSubmit, onCloseModal }: TerminationDateModalBodyProps) => {
    const formApi = useFormApi<EarlyTerminationForm>();

    const [checked, setChecked] = React.useState(formApi.getState().values.IsTerminated);

    const handleSubmit = async () => {
        formApi.validate();
        const state = formApi.getState();

        if (state.invalid)
            return;

        onSubmit({ IsTerminated: true, TerminationDate: Moment(state.values.TerminationDate).format("YYYY-MM-DDTHH:mm:ssZ"), });

        formApi.setValue("TerminationDate", null);
    }

    return (
        <ErrorBoundary>
            <div className="modal-body">
                {disabled ? null :
                    <>
                        <div className="form-group">
                            <label htmlFor="subjectNumber">Subject Number</label>
                            <TextBox id="SubjectNumber" field="SubjectNumber" type="text" disabled />
                        </div>

                        <div className="form-group">
                            <Checkbox label="Terminate from study" id="IsTerminated" field="IsTerminated" onChange={(c) => setChecked(c)} />
                        </div>
                        {checked ? <ConfigFieldDatePicker
                            id="TerminationDate"
                            field="TerminationDate"
                            className="form-group"
                            required={true}
                            includeTime={true}
                            acceptDateRange={DatePickerAcceptDateRange.PastOrPresent}
                            itemId={ConfigurableDataItemIds.TerminationDate}
                        /> : null}
                    </>
                }
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" type="button" data-automationid="TerminationDateModalSubmitButton"
                    onClick={handleSubmit}>
                    Submit
                </button>
                <button className="btn btn-primary btn-outline" data-automationid="TerminationDateModalCancelButton" onClick={() => onCloseModal()}>
                    Cancel
                </button>
            </div>
        </ErrorBoundary>
    );
}

export const TerminationDateModalBody = (props: TerminationDateModalBodyProps) => {
    return (
        <Form initialValues={props.initialValues}>
            <TerminationDateModalBodyForm  {...props} />
        </Form>
    );
}
